import React from "react";

function DefaultIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 30 30">
      <path d="M 15 3 C 8.3844276 3 3 8.3844276 3 15 C 3 21.615572 8.3844276 27 15 27 C 21.615572 27 27 21.615572 27 15 C 27 8.3844276 21.615572 3 15 3 z M 14 5.0488281 L 14 7 L 12 7 L 12 5.4570312 C 12.640665 5.2567104 13.310462 5.1169575 14 5.0488281 z M 16 5.0488281 C 17.729289 5.2196894 19.325163 5.8326699 20.679688 6.7675781 L 20 7 L 20 8 L 19 8 L 18 9 L 18 11 L 20 10 L 23 11 L 22 13 L 20 12 L 18 12 L 16 14 L 16 16 L 18 18 L 20 18 L 21 20 L 18.892578 24.216797 C 17.696702 24.720837 16.382137 25 15 25 C 14.632366 25 14.271265 24.977861 13.914062 24.939453 L 11.964844 23.035156 L 12 19 L 9 16 L 6 16 L 6 14 L 11 11 L 11 9 L 13 9 L 14 10 L 16 9 L 16 5.0488281 z" />
    </svg>
  );
}

export { DefaultIcon };
